/**
 * Phase C — Sidebar Operational Audit
 *
 * Every top-level sidebar entry is graded by three signals:
 *   1. Real backend endpoint(s) exist and return 200 on empty workspace.
 *   2. Frontend page is fully wired to those endpoints (no static arrays).
 *   3. Core happy-path works with 0 external integrations (dogfoodable).
 *
 * `status` values:
 *   - "operational"  → 80%+ ready. Ships to production.
 *   - "beta"         → Working core but rough edges or Meta OAuth pending.
 *                       Rendered with a small "beta" badge; still visible.
 *   - "hidden"       → Less than 80% ready. NOT rendered in the sidebar.
 *
 * When Meta OAuth ships, flip WhatsApp/IG inbox from "beta" → "operational".
 * When AI Cost Optimization Phase H closes, Copilot's beta badge can drop.
 */

export const MODULE_STATUS = {
  "/dashboard":   { status: "operational", note: "Fully DB-sourced. Empty-state safe." },
  "/capture":     { status: "operational", note: "Leads + Opportunities live; Inbox flagged beta below." },
  "/convert":     { status: "operational", note: "Flows/Automations/Copilot all wired." },
  "/recover":     { status: "operational", note: "Recovery Center — real data + job_queue." },
  "/insights":    { status: "operational", note: "Analytics/Attribution/Forecast/Alerts." },
  "/forge":       { status: "operational", note: "8 Forge modules + LandingPages publish flow." },
  "/experiences": { status: "operational", note: "Storefront, Products, Webinars, Revenue Assets." },
  "/amplify":     { status: "beta",        note: "Affiliates: overview + list live; commission payouts manual for now." },
  "/nexus":       { status: "operational", note: "Brand Memory, Customer Memory, Training all wired." },
  "/settings":    { status: "operational", note: "Billing (Paddle), Integrations, Email, Public Hub, Payments." },
};

// Sub-modules that render an inline "beta" indicator inside the section header.
// Everything not listed is treated as fully operational.
export const SUBMODULE_BETA = {
  "capture:inbox": "Inbox needs Meta OAuth for live IG/WhatsApp DMs.",
  "amplify:affiliates": "Affiliate program is functional; payouts require Stripe Connect.",
};
